import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { CSSTransition } from 'react-transition-group';

export const TRANSITION_DELAY = 700;
export const TRANSITION_OUT_DELAY = 350;

export const popupTransitionName = 'popup-transition';

export const CSSTransitionBox = styled(CSSTransition)<{
  pushDown?: boolean
}>(props => css`
  outline: none;
  top: ${props.pushDown ? '30%' : 'unset'};
  transform: ${props.pushDown ? 'translateY(-30%)' : 'unset'};

  &.${popupTransitionName}-appear-active,
  &.${popupTransitionName}-enter-active,
  &.${popupTransitionName}-exit {
    transition:
      opacity ${TRANSITION_DELAY}ms ease,
      transform ${TRANSITION_DELAY}ms cubic-bezier(0.175, 0.885, 0.32, 1.125);
  }

  &.${popupTransitionName}-appear,
  &.${popupTransitionName}-enter,
  &.${popupTransitionName}-exit-active {
    opacity: 0;
    transform: ${props.pushDown ? 'translateY(calc(-30% + 30rem))' : 'translateY(30rem)'};
  }

  &.${popupTransitionName}-appear-active,
  &.${popupTransitionName}-enter-active {
    opacity: 1;
    transform: ${props.pushDown ? 'translateY(-30%)' : 'none'};
  }
`);
